import { motion } from "framer-motion";

/**
 * Reveals children with a soft fade-up animation when they enter the viewport.
 * Usage: <Reveal delay={0.1}><h2>…</h2></Reveal>
 */
export default function Reveal({ children, delay = 0, y = 24, className = "", once = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.25 }}
      transition={{ duration: 0.7, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
